module.exports = __webpack_public_path__ + "media/operational-planning_de_ipad_old.f48e067b.mp4";